<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "PublicPanel"
}
</script>

<style scoped>

</style>
